import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Award } from "lucide-react";
import { RoomShell } from "@/components/RoomShell";
import { api } from "@/lib/api";

export default function HallOfFame() {
  const [list, setList] = useState([]);

  useEffect(() => { api.get("/hall-of-fame").then((r) => setList(r.data)); }, []);

  return (
    <RoomShell testid="hall-of-fame" kicker="Hall of Fame" title="Official Investigators">
      <p className="text-[#A89A80] max-w-2xl -mt-6 mb-10 leading-relaxed">
        Investigators who restored the Headquarters broadcast and earned their number. Their names are pinned here permanently.
      </p>

      {list.length === 0 ? (
        <div className="rounded-md p-12 text-center" style={{ background: "var(--wood-dark)", border: "1px dashed var(--wood-medium)" }}>
          <Award size={40} className="text-[#2C1A0F] mx-auto mb-4" />
          <p className="font-serif-hq text-2xl text-[#A89A80]">The wall is empty.</p>
          <p className="text-sm text-[#6b5f4d] mt-1">Be the first to become an Official Zombie Investigator.</p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="fame-list">
          {list.map((inv, i) => (
            <motion.div key={inv.investigator_number}
              initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}
              className="paper-card rounded-md p-6 relative">
              <span className="absolute top-4 right-4"><Award size={18} style={{ color: "#8B5A2B" }} /></span>
              <p className="font-typewriter text-[11px] uppercase tracking-[0.3em]" style={{ color: "#8B5A2B" }}>{inv.investigator_number}</p>
              <h3 className="font-serif-hq text-2xl mt-1" style={{ color: "#2A2015" }}>{inv.name}</h3>
              <p className="font-typewriter text-[11px] uppercase tracking-widest mt-3" style={{ color: "#6b5f4d" }}>{inv.badges} badges earned</p>
            </motion.div>
          ))}
        </div>
      )}
    </RoomShell>
  );
}
